import React, { useContext } from 'react';
import { useProgramMode, useProgramActions, useProgramStore } from '#client/stores/program/useProgramStore';
import { Page, Button } from '@shopify/polaris';
import { useNavigate, useParams } from 'react-router';
import { SessionContext } from '#client/contexts/SessionContext';
import { hasPermission } from '#client/utils/helpers';

export default function ProgramPageWrapper({ children }) {
    // Customer vs Staff
    const { currentUser, isCustomerAuthenticated } = useContext(SessionContext);
    const isCustomer = isCustomerAuthenticated || currentUser?.role === 'customer';
    const { id: idParam, programId: pidParam } = useParams();
    const routeProgramId = Number.parseInt(idParam ?? pidParam ?? '', 10);
    const effectiveProgramId = useProgramStore.use.programId() || (Number.isFinite(routeProgramId) ? routeProgramId : undefined);

    // Zustand store hooks
    const { handleCancelProgram } = useProgramActions();
    const { mode, setMode } = useProgramMode();
    const programId = useProgramStore.use.programId();
    const status = useProgramStore.use.status();
    const isLoading = useProgramStore.use.isLoading();

    const navigate = useNavigate();

    const handleChangeMode = (newMode) => {
        setMode(newMode);
        if (newMode === 'create') {
            navigate('/program-management/create', { viewTransition: true });
        } else if (newMode === 'edit') {
            navigate(`/program-management/edit/${programId}`, { viewTransition: true });
        } else {
            navigate(`/program-management/view/${programId}`, { viewTransition: true });
        }
    };

    // Hide Edit/Cancel for customers
    let secondaryAction;
    if (!isCustomer) {
        if (mode === 'view' && status !== 'Archived' && hasPermission(currentUser, 'programEdit')) {
            secondaryAction = (
                <Button onClick={() => handleChangeMode('edit')} disabled={isLoading}>
                    Edit
                </Button>
            );
        } else if (mode === 'edit') {
            secondaryAction = (
                <Button onClick={() => handleCancelProgram(navigate)} disabled={isLoading}>
                    Cancel
                </Button>
            );
        } else {
            secondaryAction = '';
        }
    } else {
        secondaryAction = '';
    }

    return (
        <Page
            title={mode === 'create' ? 'Create Program' : mode === 'edit' ? 'Edit Program' : mode === 'view' ? 'View Program' : 'Program'}
            primaryAction={
                effectiveProgramId
                    ? {
                          content: 'Manage Vouchers',
                          onAction: () => navigate(isCustomer ? `/customer/voucher-list/${effectiveProgramId}` : `/voucher-list/${effectiveProgramId}`, { viewTransition: true }),
                      }
                    : undefined
            }
            secondaryActions={secondaryAction}
            fullWidth
        >
            {children}
        </Page>
    );
}
